import React from "react";
import NavItem from "./HomeNavItem";
import hardLinks from "../../links";

import "./Home.scss";
import {
  featuredLinksSelectors,
  selectIsAdminAuthenticated,
  useAppSelector,
} from "../../store";
import { motion } from "framer-motion";
import { pageVariants } from "../../App";

type Props = {};

function Home(props: Props) {
  const featuredLinks = useAppSelector(featuredLinksSelectors.selectAll);
  const isAdminAuthenticated = useAppSelector(selectIsAdminAuthenticated);
  const links = [
    ...hardLinks.filter((ev) => ev.href !== "/admin" || isAdminAuthenticated),
    ...featuredLinks.filter((value) => value.showOnHome),
  ];

  return (
    <motion.div
      className="home"
      variants={pageVariants}
      initial="initial"
      animate="in"
      exit="out"
    >
      <div className="content">
        <div className="text-container">
          <div className="text typewriter">
            Hello,
            <br />
            I'm Clarence Manuel.
            <br />
            I'm a Full-Stack Web Developer.
          </div>
        </div>
        <div className="nav-container">
          {links &&
            links.map((item, index) => {
              if (item.href === "/") return null;
              return (
                <NavItem
                  iconSrc={item.iconSrc}
                  name={item.name}
                  path={item.href}
                  text={item.text}
                  key={index}
                  external={item.external}
                />
              );
            })}
        </div>
      </div>
    </motion.div>
  );
}
export { Home as default };
